import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const computeAnswer = (answer, questionType) => {
  return {
    ...([
      "Short answer",
      "Personal Data",
      "Number",
      "Paragraph",
      "Date",
      "Datetime",
      "Time",
      "User Location",
    ].includes(questionType)
      ? { answerValue: answer }
      : questionType === "Date String"
      ? { answerValue: dayjs(answer).format("DD-MM-YYYY") }
      : questionType === "File upload"
      ? { fileId: Number(answer) }
      : questionType === "Reservation"
      ? { reservationId: Number(answer) }
      : { answerId: Number(answer) }),
  };
};

const parseAnswer = (answer, questionType) => {
  return [
    "Short answer",
    "Personal Data",
    "Number",
    "Paragraph",
    "Date",
    "Datetime",
    "Time",
    "Reservation",
    "User Location",
  ].includes(questionType)
    ? answer.answerValue
    : questionType === "Date String"
    ? dayjs(answer.answerValue, "DD-MM-YYYY").toISOString()
    : questionType === "File upload"
    ? answer.fileId
    : questionType === "Reservation"
    ? answer.reservationId
    : String(answer.answerId);
};

export const computePartial = (survey, values, submissionId, status = "DRAFT") => {
  return {
    ...(submissionId ? { id: submissionId } : {}),
    contentId: Number(survey.contentId),
    status: status,
    questions: survey.definition.sections
      .map((section) =>
        section.questions.map((question) => ({
          questionId: question.id,
          answers: values?.[question.id]
            ? Array.isArray(values[question.id])
              ? values[question.id].map((answer) => computeAnswer(answer, question.questionType))
              : [computeAnswer(values[question.id], question.questionType)]
            : [],
        }))
      )
      .flat(),
  };
};

export const parseSubmission = (survey, submission) => {
  return Object.fromEntries(
    survey?.definition?.sections
      ?.map((section) =>
        section?.questions?.map((question) => {
          const answers = submission?.answers
            ?.filter((answer) => answer.questionId === question.id)
            .map((answer) => ({
              ...question.answers.find((ans) => ans.id === answer.answerId),
              ...answer,
            }));
          const value =
            answers?.length > 0
              ? ["Checkboxes"].includes(question.questionType)
                ? answers.map((answer) => parseAnswer(answer, question.questionType))
                : parseAnswer(answers[0], question.questionType)
              : null;
          return [question.id, value];
        })
      )
      .flat()
  );
};

export const getAnswerValue = (survey, answers, sectionIndex, questionIndex) => {
  const question = survey?.definition?.sections?.[sectionIndex]?.questions?.[questionIndex];
  const answer = answers?.find((answer) => answer?.questionId === question?.id);
  const answerLabel = question?.answers?.find(
    (ans) => Number(ans?.id) === Number(answer?.answerId)
  )?.label;

  return question?.id ? { ...answer, label: answerLabel } : null;
};

export const getAnswerValueFromType = (survey, answers, sectionIndex, questionType) => {
  const questionId = survey?.definition?.sections?.[sectionIndex]?.questions?.find(
    (question) => question.questionType === questionType
  )?.id;
  return questionId ? answers?.find((answer) => answer.questionId === questionId) : null;
};
